import { clsx } from "clsx";
import InstagramIcon from "components/icons/social/instagram.svg?react";
import TwitterIcon from "components/icons/social/twitter.svg?react";
import RedditIcon from "components/icons/social/reddit.svg?react";
import OnlyfansIcon from "components/icons/social/onlyfans.svg?react";
import ManyvidsIcon from "components/icons/social/manyvids.svg?react";
import PatreonIcon from "components/icons/social/patreon.svg?react";
import PornhubIcon from "components/icons/social/pornhub.svg?react";
import XhamsterIcon from "components/icons/social/xhamster.svg?react";
import ChaturbateIcon from "components/icons/social/chaturbate.svg?react";
import MyfreecamsIcon from "components/icons/social/myfreecams.svg?react";
import FanslyIcon from "components/icons/social/fansly.svg?react";
import DefaultIcon from "components/icons/websiteIcon.svg?react";
import CamsodaIcon from "components/icons/social/camsoda.svg?react";
import FancentroIcon from "components/icons/social/fancentro.svg?react";
import YouTubeIcon from "components/icons/social/youtube.svg?react";
import DiscordIcon from "components/icons/social/discord.svg?react";
import FacebookIcon from "components/icons/social/facebook.svg?react";
import "./style/SocialIcon.scss";

interface ISocialIconProps {
  name: string;
}

export const getIcon = (name: string) => {
  switch (name) {
  case "twitter": return <TwitterIcon />;
  case "instagram": return <InstagramIcon />;
  case "reddit": return <RedditIcon />;
  case "onlyfans": return <OnlyfansIcon />;
  case "manyvids": return <ManyvidsIcon />;
  case "patreon": return <PatreonIcon />;
  case "pornhub": return <PornhubIcon />;
  case "xhamster": return <XhamsterIcon />;
  case "chaturbate": return <ChaturbateIcon />;
  case "myfreecams": return <MyfreecamsIcon />;
  case "fansly": return <FanslyIcon />;
  case "camsoda": return <CamsodaIcon />;
  case "fancentro": return <FancentroIcon />;
  case "youtube": return <YouTubeIcon />;
  case "discord": return <DiscordIcon />;
  case "facebook": return <FacebookIcon />;
  default: return <DefaultIcon />;
  }
};

export const SocialIcon: React.FC<ISocialIconProps> = (props) => {
  const { name } = props;

  return (
    <span className={clsx("SocialIcon", `SocialIcon_${name}`)}>{getIcon(name)}</span>
  );
};

